import { EllipsisHorizontalIcon } from "@heroicons/react/24/outline";
import { LoaderSpinner } from "../../../components/LoaderSpinner";
import { OverlayGrayBackground } from "../../../components/OverlayGrayBackground";
import { NET_TERMS, PAYMENT_TERMS, parseEmails, StatusPill, TermValues } from "./VendorTable";
import { parseVendorAccount } from "./vendorDisplay";

const VendorCardList = ({
    vendors = [],
    isFirstLoadComplete,
    isLoading,
    onRowClick,
    onOpenActions,
}) => (
    <div className="relative mt-3 md:hidden">
        {isFirstLoadComplete && isLoading && <OverlayGrayBackground />}
        {!isFirstLoadComplete && isLoading ? (
            <div className="flex h-60 items-center justify-center">
                <LoaderSpinner width="70" height="70" border="3" colorSpinner="black" />
            </div>
        ) : vendors.length ? (
            <div className="flex flex-col gap-2 px-3 pb-4">
                {vendors.map((vendor) => {
                    const emailList = parseEmails(vendor.emails);
                    const { category, accountNumber, status } = parseVendorAccount(vendor);

                    return (
                        <div
                            key={vendor.id}
                            role="button"
                            tabIndex={0}
                            className="w-full min-w-0 rounded-xl border border-border bg-white p-3 text-left"
                            onClick={() => onRowClick?.(vendor)}
                            onKeyDown={(event) => {
                                if (event.target !== event.currentTarget) return;
                                if (event.key === "Enter" || event.key === " ") {
                                    event.preventDefault();
                                    onRowClick?.(vendor);
                                }
                            }}
                        >
                            <div className="flex min-w-0 items-start gap-2">
                                <div className="line-clamp-2 min-w-0 flex-1 text-[15px] font-semibold leading-5 text-gray-900">
                                    <span className={status === "Active" ? "" : "text-gray-600"}>
                                        {vendor.name || "—"}
                                    </span>
                                </div>
                                <StatusPill status={status} />
                                <button
                                    type="button"
                                    aria-label={`Actions for ${vendor.name || "vendor"}`}
                                    title="Actions"
                                    className="-mr-1 -mt-1 shrink-0 rounded-md p-1 text-gray-700 hover:bg-gray-100"
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        onOpenActions?.(vendor);
                                    }}
                                    onKeyDown={(event) => event.stopPropagation()}
                                >
                                    <EllipsisHorizontalIcon className="h-5 w-5" />
                                </button>
                            </div>
                            <div className="mt-1 text-sm text-gray-500">
                                {category
                                    ? `${category}${accountNumber ? ` · #${accountNumber}` : ""}`
                                    : accountNumber ? `#${accountNumber}` : "No category"}
                            </div>
                            <div className="mt-0.5 min-w-0 truncate text-sm text-gray-700">
                                {emailList.length ? (
                                    <>
                                        <span>{emailList[0]}</span>
                                        {emailList.length > 1 && (
                                            <span className="ml-1.5 text-gray-500">
                                                +{emailList.length - 1} more
                                            </span>
                                        )}
                                    </>
                                ) : (
                                    <span className="text-gray-400">—</span>
                                )}
                            </div>
                            <div className="mt-2.5 grid grid-cols-[2rem_minmax(0,1fr)] items-start gap-x-2 gap-y-1.5 border-t border-dashed border-gray-200 pt-2.5 text-sm">
                                <span className="text-gray-500">Pay</span>
                                <TermValues terms={PAYMENT_TERMS} vendor={vendor} suffix="%" compact />
                                <span className="text-gray-500">Net</span>
                                <TermValues terms={NET_TERMS} vendor={vendor} suffix="d" compact />
                            </div>
                        </div>
                    );
                })}
            </div>
        ) : (
            <div className="px-4 py-10 text-center text-sm text-gray-500">
                No vendors match the current filters.
            </div>
        )}
    </div>
);

export default VendorCardList;
